import { Toast } from "primereact/toast";
import { createContext, useContext, useRef } from "react";

export const ToastContext = createContext();

export const useToast = () => {
  const toast = useContext(ToastContext);

  const SHOW_TOAST = (severity) => (summary, detail) => toast.current.show({
    severity,
    summary,
    detail,
    life: 10000,
  });

  return {
    info: SHOW_TOAST("info"),
    success: SHOW_TOAST("success"),
    error: SHOW_TOAST("error"),
    warning: SHOW_TOAST("warn"),
  };
};

export const ToastWrapper = ({ children }) => {
  const toast = useRef();
  return (
    <ToastContext.Provider value={toast}>
      <Toast ref={toast}></Toast>
      {children}
    </ToastContext.Provider>);
};
